import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import { useMyGames } from "@seabrookstudios/pitch2table";
import CardHeader from "@mui/material/CardHeader";
import AddGameFullScreenDialog from "../games/AddGameFullScreenDialog";
import Button from "@mui/material/Button";
import Add from "@mui/icons-material/Add";

export const GetStartedCard = () => {
  const { data: games = [], isLoading } = useMyGames();

  if (isLoading || games.length > 0) {
    return null;
  }

  return (
    <Card
      sx={{
        background: "linear-gradient(135deg, #608bb7 0%, #523f5f 80%)",
        color: "white",
      }}
    >
      <CardHeader title="Ready to start your board game journey?" />
      <CardContent style={{ maxWidth: "66ch" }}>
        <Typography>
          The first step to getting that game signed is to add it. Once you have done that you can start shortlisting
          publishers, recording what you&apos;ve sent them and organising follow ups.
        </Typography>
        <Typography pt={2}>
          If you&apos;re not ready for that yet, you can record play tests, work on your rules or invite collaborators.
        </Typography>
        <Typography pt={2}>
          And if you&apos;ve already got a signed game, congratulations! You can now start tracking royalties and
          securely storing your contracts.
        </Typography>
        <Typography pt={2}>It all starts with a game.</Typography>
      </CardContent>
      <CardActions>
        <AddGameFullScreenDialog
          CustomControl={
            <Button variant="contained" size="large" startIcon={<Add />}>
              Add Game
            </Button>
          }
        />
      </CardActions>
    </Card>
  );
};
